import {
  Datatype,
  IReference,
  ReferencePathDirection,
  ReferenceType,
} from '@framework/engine';

export enum SubmissionDataCodes {
  IsIntegration = 'richiestaInIntegrazione',
  PhaseId = 'id',
  PhaseName = 'denominazione',
  ActivityId = 'idAttivita',
  RequestId = 'idRichiesta',
}

/**
 * Crea una reference per un valore contestuale della submission (metadata).
 */
function createSubmissionDataReference(
  datatype: Datatype.Boolean | Datatype.String,
  code: string,
  label: string,
): IReference {
  return {
    type: ReferenceType.Metadata,
    id: `submission_data_${code}`,
    code,
    label,
    path: [
      {
        direction: ReferencePathDirection.Absolute,
        code: ReferenceType.Metadata,
      },
      {
        direction: ReferencePathDirection.Child,
        code: 'submission',
      },
    ],
    field: {
      type: datatype,
    },
    group: 'Richiesta',
  };
}

export interface IGetSubmissionDataReferencesOptions {
  /** Se true, include anche i riferimenti disponibili solo nelle sezioni dati di Backoffice */
  backoffice?: boolean;
}

/**
 * Ritorna le reference per i valori contestuali della submission (dati di metadata).
 */
export function getSubmissionDataReferences(
  options?: IGetSubmissionDataReferencesOptions,
): IReference[] {
  const references = [
    createSubmissionDataReference(
      Datatype.Boolean,
      SubmissionDataCodes.IsIntegration,
      'Richiesta in Integrazione',
    ),
    createSubmissionDataReference(
      Datatype.String,
      SubmissionDataCodes.PhaseId,
      'Fase del Procedimento: ID',
    ),
    createSubmissionDataReference(
      Datatype.String,
      SubmissionDataCodes.PhaseName,
      'Fase del Procedimento: Denominazione',
    ),
  ];

  // `idAttivita` e `idRichiesta` sono valorizzati solo nelle sezioni dati di Backoffice
  if (options?.backoffice) {
    references.push(
      createSubmissionDataReference(
        Datatype.String,
        SubmissionDataCodes.ActivityId,
        'ID Attività',
      ),
      createSubmissionDataReference(
        Datatype.String,
        SubmissionDataCodes.RequestId,
        'ID Richiesta',
      ),
    );
  }

  return references;
}
